export const TemplateTaskActionTypes = {
  FETCH_TEMPLATE_TASKS_START: "FETCH_TEMPLATE_TASKS_START_NEW",
  FETCH_TEMPLATE_TASKS_SUCCESS: "FETCH_TEMPLATE_TASKS_SUCCESS_NEW",
  FETCH_TEMPLATE_TASKS_FAILURE: "FETCH_TEMPLATE_TASKS_FAILURE_NEW",
  SET_SEARCH_TEMPLATE_TASKS_QUERY: "SET_SEARCH_TEMPLATE_TASKS_QUERY_NEW",
  ADD_SELECTED_TEMPLATE_TASKS: "ADD_SELECTED_TEMPLATE_TASKS_NEW",
  DELETE_SELECTED_TEMPLATE_TASKS: "DELETE_SELECTED_TEMPLATE_TASKS_NEW",
  SET_SELECTED_TEMPLATE_TASKS: "SET_SELECTED_TEMPLATE_TASKS_NEW",
  SET_TEMPLATE_TASKS_ON_PAGE: "SET_TEMPLATE_TASKS_ON_PAGE_NEW",
};
